import { Injectable } from '@angular/core';

import { Http, Headers, RequestOptions } from '@angular/http';

import { UserData } from '../user-data';
import { CommonData } from '../../providers/common-data';
import { NativeScriptHttpModule } from "nativescript-angular/http";

/*
  Generated class for the LicenseplateProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LicenseplateProviderNew {
  private apikey = 'e8341f81fb3ba9aeb2463a893a34be793f7338c9';
  private apibaseurl = 'https://api.platerecognizer.com/v1/plate-reader/';

  constructor(public http: Http, public userData: UserData, public common: CommonData) {
    
  }

  remoteFindLicenseplate(base64data){
    return new Promise(resolve => {

      const uploadData = new FormData();
  
      let body = new FormData();
      body.append('upload', base64data);
      body.append('regions', 'ch');
      body.append('regions', 'de');
      body.append('regions', 'li');
      body.append('regions', 'it');
      body.append('regions', 'at');
      body.append('regions', 'fr');
      body.append('regions', 'ba');
      body.append('regions', 'be');
      body.append('regions', 'dk');
      body.append('regions', 'es');
      body.append('regions', 'fi');
      body.append('regions', 'gb');
      body.append('regions', 'lu');
      body.append('regions', 'me');
      body.append('regions', 'nl');
      body.append('regions', 'no');
      body.append('regions', 'pt');
      body.append('regions', 'ro');
      body.append('regions', 'sk');
      body.append('regions', 'si');
      body.append('regions', 'se');
      
      let headers = new Headers(
      {
          'Authorization' : 'Token ' + this.apikey
      });
      let options = new RequestOptions({ headers: headers });
        
      //console.log(body);
      this.http.post(this.apibaseurl,body,options)
      .subscribe(data => {
        console.log(data.json());
        let plate =  this.platePostProcess(data.json());
        resolve(plate);      
      }, error => {
        console.log('HTTP Error, no answer');
        console.log(error);
      
      });

    });       
  }

  platePostProcess(plateresult){
    //console.log(response.results[0]);
    if(plateresult.results.length>0){
      let plr = plateresult.results[0];
      let plate = "";
      if(plr.region.code == "ch"){
        plate = plr.plate;
        //-- check if ------
        var canton = plate.substring(0, 2);
        var hasNumber = /\d/;
        //hasNumber.test()
        if(hasNumber.test(canton)){
          for(let c = 0; c < plr.candidates.length; c++){
            let candidate = plr.candidates[c].plate;
            canton = candidate.substring(0, 2);
            if(!hasNumber.test(canton)){
              plate = plr.candidates[c].plate;
              break;
            }
          }
          
        }
      }
      else{
        plate = plr.plate;
      }
      let tmp = [];
      tmp["plate"] = plate.toUpperCase();
      tmp["box"] = plr.box;
      return tmp;
    }
    else{
      return "";
    }


   }  



}



// WEBPACK FOOTER //
// ./src/providers/licenseplate/licenseplate_new.ts